import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { FormValidatorsService } from '../../../shared/services/form-validators.service';
import {
  CountryItem,
  DtoTravelBookingGmgCreate,
  DtoTravelDonationCreate,
  MediaItem,
  TravelItem,
} from '../../../api/models';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  of,
  switchMap,
} from 'rxjs';
import { CountryControllerGetAll$Params } from '../../../api/fn/country/country-controller-get-all';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  BookingService,
  CountryService,
  InvitationService,
  TravelService,
} from '../../../api/services';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../../../guards/services/auth.service';
import { enumPaymentMethod } from '../../../shared/utils/enum-payment-method';
import {
  foreignFiscalCodeValidator,
  italianFiscalCodeValidator,
} from '../../../customValidators/fiscal-code.validator';

@Component({
  selector: 'app-travel-join-donate',
  templateUrl: './travel-join-donate.component.html',
  styleUrl: './travel-join-donate.component.scss',
})
export class TravelJoinDonateComponent {
  items: MenuItem[] | undefined;
  travel?: TravelItem;
  loading = false;
  menuIndex = 0;
  tcAccept = new FormControl(false);
  tcRead = false;
  visible: boolean = false;
  luggage_attachment?: MediaItem;
  cancellation_attachment?: MediaItem;
  enumPaymentMethod = enumPaymentMethod;
  // cfRegex: RegExp =
  //   /^(?:[A-Z]{6}[0-9]{2}[A-EHLMPR-T][0-9]{2}[A-Z][0-9]{3}[A-Z]|[A-Z0-9]{2,28})$/;
  suggestedCountries: CountryItem[] = [];
  amount = new FormControl<number>(50, {
    validators: [Validators.required, Validators.min(50)],
    nonNullable: true,
  });

  autocompleteCountries$ = new BehaviorSubject<string>('');
  frmJoin = new FormGroup({
    anonymous: new FormControl(false),
    addl_service: new FormArray<
      FormGroup<{
        title: FormControl;
        price: FormControl;
        qty: FormControl;
      }>
    >([]),

    accountholder_name: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_last_name: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_country_iso: new FormControl<CountryItem | null>(null, {
      validators: [Validators.required],
      nonNullable: true,
    }),
    accountholder_province: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_city: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyStringValidator,
    ]),
    accountholder_address: new FormControl(undefined, Validators.required),
    accountholder_zip_code: new FormControl(undefined, Validators.required),
    accountholder_mobile_phone: new FormControl(undefined, [
      Validators.required,
      FormValidatorsService.onlyNumberValidator,
    ]),
    accountholder_email: new FormControl('', {
      validators: [Validators.required, Validators.email],
    }),

    accountholder_fiscal_code: new FormControl(undefined, [
      Validators.required,
      italianFiscalCodeValidator(),
    ]),
    confirm_email: new FormControl({ value: '', disabled: true }, [
      Validators.required,
      Validators.email,
    ]),
    payment_method: new FormControl<enumPaymentMethod | undefined>(
      undefined,
      Validators.required,
    ),
    third_party_donation: new FormControl<boolean>(false, Validators.required),
  });
  payed = new FormControl<boolean>(false, { nonNullable: true });
  constructor(
    private ar: ActivatedRoute,
    private router: Router,
    private travelService: TravelService,
    private countryService: CountryService,
    private bookingService: BookingService,
    private messageService: MessageService,
    private slugifyPipe: SlugifyPipe,
    private invitationService: InvitationService,
    private title: Title,
    private auth: AuthService,
  ) {}
  filterCountries(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteCountries$.next(query);
  }

  ngOnInit() {
    this.tcAccept.valueChanges.subscribe((val) => {
      if (!val) this.tcRead = false;
    });
    //PER LA VALIDAZIONE CODICE FISCALE,SE IT O SE ESTERO
    const countryControl = this.frmJoin.get('accountholder_country_iso');
    const cfControl = this.frmJoin.get('accountholder_fiscal_code');
    countryControl?.valueChanges.subscribe((country) => {
      if (!cfControl) return;
      if (country) {
        if (country?.ISO === 'IT') {
          (cfControl.setValidators([
            Validators.required,
            italianFiscalCodeValidator(),
          ]),
            cfControl.updateValueAndValidity());
        } else {
          (cfControl.setValidators([
            Validators.required,
            foreignFiscalCodeValidator(),
          ]),
            cfControl.updateValueAndValidity());
        }
      }
    });
    //^PER LA VALIDAZIONE CODICE FISCALE,SE IT O SE ESTERO
    this.title.setTitle('SocialTravels - Partecipa');
    this.getOneTravel();
    this.autocompleteCountries$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          if (query) {
            let params: CountryControllerGetAll$Params = {
              query,
            };
            return this.countryService.countryControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        }),
      )
      .subscribe({
        next: (res) => {
          this.suggestedCountries = res.data.list;
          if (this.suggestedCountries.length === 1) {
            this.frmJoin
              .get('accountholder_country_iso')
              ?.setValue(this.suggestedCountries[0]);
          }
        },
      });

    this.frmJoin.get('accountholder_email')!.valueChanges.subscribe((value) => {
      if (value) {
        this.frmJoin.get('confirm_email')!.enable();
      } else {
        this.frmJoin.get('confirm_email')!.disable();
        this.frmJoin.get('confirm_email')!.setValue('');
      }
    });

    this.ar.queryParams.subscribe((p) => {
      if (p['third-party-donation']) {
        this.frmJoin.get('third_party_donation')?.setValue(true);
        this.tcAccept.setValue(true);
        return;
      }
      // });
      // this.ar.queryParams.subscribe((p) => {
      if (this.travel?.checkout_advance) {
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.STRIPE_ADVANCE);
      } else {
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.STRIPE_TRANSFER);
      }
    });
  }
  openTc() {
    this.visible = true;
  }

  onTcClose() {
    this.tcRead = true;
    this.tcAccept.setValue(true);
  }
  getOneTravel() {
    this.ar.params.subscribe((p: Params) => {
      if (p) {
        const id = p['id'];
        this.loading = true;
        this.travelService.travelControllerGetTravel({ id }).subscribe({
          next: (res) => {
            this.travel = res.data;
            if (this.travel?.draft) {
              this.router.navigateByUrl('/');
            }
            // if(this.travel.has_flights === false){
            //   this.frmJoin.get('with_flights')?.setValue(false);
            // }else{
            //   this.frmJoin.get('with_flights')?.setValue(true);
            // }

            this.setBreadcrumb();

            for (let i = 0; i < this.travel.addl_services.length; i++) {
              this.addService(i);
            }
            if (this.travel?.attachments) {
              this.luggage_attachment = this.travel.attachments.find((x) =>
                x.attachment.path.includes('luggage-insurance'),
              )?.attachment;
              this.cancellation_attachment = this.travel.attachments.find((x) =>
                x.attachment.path.includes('cancellation-insurance'),
              )?.attachment;
            }
            this.loading = false;
          },
        });
      }
    });
  }
  setBreadcrumb() {
    const slugifyName = this.slugifyPipe.transform(this.travel!.name);
    this.items = [
      { label: 'Homepage', routerLink: '/' },
      {
        label: this.travel?.countries[0].country.name,
        routerLink: [
          '/viaggi-di-gruppo',
          this.travel?.countries[0].country.ISO,
          this.travel?.countries[0].country.name,
        ],
      },
      {
        label: this.travel?.name,
        routerLink: [
          '/viaggi-di-gruppo',
          this.travel?.countries[0].country.ISO,
          this.travel?.countries[0].country.name,
          this.travel?.id,
          slugifyName,
        ],
      },
      { label: 'Donazione ' },
    ];
  }
  addService(i: number) {
    const frm = new FormGroup({
      title: new FormControl(this.travel!.addl_services[i].title),
      price: new FormControl(this.travel!.addl_services[i].price),
      qty: new FormControl(0),
    });
    (this.frmJoin.get('addl_service') as FormArray)!.push(frm);
  }
  getaddlServiceMembersTotal(i: number) {
    let total = 0;
    if (this.frmAddlServiceControls[i].get('qty')?.value > 0) {
      total += this.frmAddlServiceControls[i].get('qty')?.value;
      return total;
    } else {
      return total;
    }
  }

  get frmAddlService() {
    return this.frmJoin.get('addl_service') as FormArray;
  }
  get frmAddlServiceControls() {
    return <FormGroup[]>(
      (this.frmJoin.get('addl_service') as FormArray).controls
    );
  }
  increasePeople(index: number) {
    const members = this.frmAddlService.at(index).get('qty')!;
    members.setValue(members.value + 1);
  }

  decreasePeople(index: number) {
    const members = this.frmAddlService.at(index).get('qty')!;
    if (members.value > 0) {
      members.setValue(members.value - 1);
    }
  }
  submit() {
    const frmJoin = this.frmJoin.value;
    const country_obj = this.frmJoin.get('accountholder_country_iso')!.value!;
    const payed = this.payed.value;
    const body: DtoTravelDonationCreate = {
      accountholder_address: frmJoin.accountholder_address!,
      accountholder_city: frmJoin.accountholder_city!,
      accountholder_country_iso: country_obj.ISO,
      accountholder_email: frmJoin.accountholder_email!,
      accountholder_fiscal_code: frmJoin.accountholder_fiscal_code!,
      accountholder_last_name: frmJoin.accountholder_last_name!,
      accountholder_mobile_phone: frmJoin.accountholder_mobile_phone!,
      accountholder_name: frmJoin.accountholder_name!,
      accountholder_province: frmJoin.accountholder_province!,
      accountholder_zip_code: frmJoin.accountholder_zip_code!,
      amount: this.amount.value, // numero,
      anonymous: frmJoin.anonymous!,
      payment_method: frmJoin.payment_method!,
      payed: payed,
      third_party_donation:
        this.frmJoin.get('third_party_donation')?.value === true,
    };
    console.log('PAYED INVIATO:', payed);
    console.log('BODY:', body);
    this.loading = true;
    this.travelService
      .travelControllerCreateTravelDonation({
        id: this.travel?.id!,
        body,
      })
      .subscribe({
        next: (res) => {
          this.loading = false;

          if (this.frmJoin.get('third_party_donation')?.value === true) {
            this.messageService.add({
              severity: 'success',
              summary: 'Donazione',
              detail: 'Operazione registrata con successo.',
            });
            this.router.navigate([
              '/viaggi-di-gruppo/travel-management',
              this.travel?.id!,
            ]);
          } else {
            window.location.href = res.data.redirect_url;
          }
        },
        error: (err) => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Donazione',
            detail: 'Impossibile creare la donazione.',
          });
        },
      });
  }
  paymentMethod(m: enumPaymentMethod) {
    switch (m) {
      case enumPaymentMethod.STRIPE_ADVANCE:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.STRIPE_ADVANCE);
        break;
      case enumPaymentMethod.STRIPE_TRANSFER:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.STRIPE_TRANSFER);
        break;
      case enumPaymentMethod.BANK_TRANSFER_ADV:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.BANK_TRANSFER_ADV);
        break;
      case enumPaymentMethod.BANK_TRANSFER_PAYOFF:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.BANK_TRANSFER_PAYOFF);
        break;
      case enumPaymentMethod.CASH_ADV:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.CASH_ADV);
        break;
      case enumPaymentMethod.CASH_PAYOFF:
        this.frmJoin
          .get('payment_method')
          ?.setValue(enumPaymentMethod.CASH_PAYOFF);
        break;
    }
  }

  // goToNextSection() {
  //   const amountValue = this.amount.value;

  //   // se amount è impostato e maggiore di 1
  //   if (amountValue && amountValue > 1) {
  //     this.menuIndex = 2; // apri la sezione successiva
  //   }
  // }
}
